import React, { useEffect, useState } from "react";
import {
  GeneralDetail,
  Edit,
  Contract,
  SalesUSer,
  UserIconB,
} from "../../assets/svg";
import { AddPrimaryButton, Badge } from "../../components/micro/input";
import {
  DeleteEquipment,
  DeleteStaff,
  getByIdOutlet,
} from "../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";
import RippleLoader from "../../components/loader/RippleLoader";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import Action from "../../components/common/Action";
import { useLocation, useNavigate } from "react-router-dom";
import Toggles from "../../components/common/Toggles";
import EditGeneralDetails from "./modal/EditGeneralDetails";
import AddNewEquipment from "./modal/AddEditEquipment";
import AddEditStaff from "./modal/EditCompanyPreferred";
import AddEditManager from "./modal/AddEditSales";
import AddEditTransfer from "./modal/AddEditTransfer";
import { updateStaffStatus } from "../../redux/staffs/slice";

const OutletInformation = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreferredOpen, setIsPreferredOpen] = useState(false);
  const [isEquipmentOpen, setIsEquipmentOpen] = useState(false);
  const [isTransfer, setIsTransfer] = useState(false);
  const [isSalesOpen, setIsSalesOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [productDelete, setProductDelete] = useState(null);
  const [managerData, setSalesPersonData] = useState(null);
  const companyData = JSON.parse(sessionStorage.getItem("companyData") || "{}")
    ?.company?.id;
  const [modalData, setModalData] = useState(null);
  const [staffDelete, SetStaffDelete] = useState(false);
  const [equipmentDelete, SetEquipmentDelete] = useState(false);
  const outletData = location?.state?.staff;

  // Selector
  const { getOutletData, loading } = useSelector((store) => ({
    getOutletData: store?.companiesData?.getByIdOutletStatus?.data?.data,
    loading: store?.companiesData?.loading,
  }));

  useEffect(() => {
    if (outletData?.id) {
      dispatch(getByIdOutlet(outletData?.id));
    }
  }, [outletData?.id]);

  const closeModal = () => {
    setIsModalOpen(false);
    setIsPreferredOpen(false);
    setIsSalesOpen(false);
    setIsEquipmentOpen(false);
    setIsTransfer(false);
  };

  const handleCloseSalesModal = () => {
    setSalesPersonData([]);
    setIsSalesOpen(false);
  };

  const handleEditSales = (manager) => {
    if (!manager || manager.length === 0) return;
    setSalesPersonData(manager);
    setIsSalesOpen(true);
  };

  const deleteEquipment = () => {
    setIsLoading(true);
    dispatch(DeleteEquipment(productDelete))
      .then((res) => {
        if (res.type === "DeleteEquipment/fulfilled") {
          dispatch(getByIdOutlet(outletData?.id));
        }
        setIsLoading(false);
        SetEquipmentDelete(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const deleteStaff = () => {
    setIsLoading(true);
    dispatch(DeleteStaff(productDelete))
      .then((res) => {
        if (res.type === "DeleteStaff/fulfilled") {
          dispatch(getByIdOutlet(outletData?.id));
        }
        setIsLoading(false);
        SetStaffDelete(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const updateStatus = (element, status, isActive) => {
    dispatch(
      updateStaffStatus({
        id: element?.id,
        data: {
          status: status,
          is_active: isActive,
        },
      })
    ).then((res) => {
      if (res.type === "updateStaffStatus/fulfilled") {
        dispatch(getByIdOutlet(outletData?.id));
      }
    });
  };

  const handleToggle = (element) => {
    const newStatus = element.status === "active" ? "inactive" : "active";
    const isActive = newStatus === "active";

    updateStatus(element, newStatus, isActive);
  };

  return (
    <>
      <div className="space-y-5">
        {loading ? (
          <RippleLoader />
        ) : (
          <>
            {/* Information Panels */}
            <div className="grid gap-4">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                {/* General Details */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg h-64">
                  <div className="flex items-center justify-between bg-background_grey py-4 px-6 border-b border-b-Grey">
                    <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey">
                      <GeneralDetail />
                      <span>General Details</span>
                    </h2>
                    <button
                      className="cursor-pointer"
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                    >
                      <Edit />
                    </button>
                  </div>
                  <div className="py-5 px-6 grid grid-cols-2 gap-y-4 ">
                    <div className="space-y-1">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        Outlet Name:
                      </p>
                      <p className="text-sm font-normal text-primaryBlack font-Proxima">
                        {getOutletData?.name || "-"}
                      </p>
                    </div>
                    <div className="col-span-2 space-y-1">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        Address:
                      </p>
                      <div className="text-sm font-normal text-primaryBlack font-Proxima">
                        <p className="text-sm font-normal text-primaryBlack font-Proxima">
                          {getOutletData?.address || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Contract Details */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg h-64">
                  <div className="flex items-center justify-between bg-background_grey py-4 px-6 border-b border-b-Grey">
                    <div className="flex items-center gap-2">
                      <Contract />
                      <h2 className="text-xl text-mgrey font-medium">
                        Contract Details
                      </h2>
                    </div>
                  </div>

                  {getOutletData?.outletContract ? (
                    <div>
                      <div className="px-6 py-4 space-y-3">
                        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                          <div>
                            <p className="text-xs text-textSecondary font-Proxima">
                              Contract Status
                            </p>
                            <p className="text-sm text-mgrey font-Proxima">
                              {getOutletData?.outletContract?.contrat_status ||
                                "-"}
                            </p>
                          </div>

                          <div>
                            <p className="text-xs text-textSecondary font-Proxima">
                              Expiry date
                            </p>
                            <p className="text-sm text-mgrey font-Proxima">
                              <p>
                                {getOutletData?.outletContract?.expiry_date ||
                                  "-"}
                              </p>
                            </p>
                          </div>
                        </div>

                        <div>
                          <p className="text-xs text-textSecondary font-Proxima">
                            Available Count
                          </p>
                          <p className="text-sm text-mgrey font-Proxima">
                            {getOutletData?.outletContract?.remianing_count}/
                            {getOutletData?.outletContract?.total_count}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-center text-center items-center h-32">
                      <div>
                        <p className="text-[14px] text-textSecondary font-normal font-Proxima">
                          “Not Recurring Contract”
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                {/* Manager */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg h-64 overflow-x-hidden overflow-y-auto">
                  <div className="flex items-center justify-between bg-background_grey py-4 px-6 border-b border-b-Grey">
                    <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey">
                      <SalesUSer />
                      <span>Manager</span>
                    </h2>
                    {getOutletData?.manager_details?.length > 0 ? (
                      <button
                        className="cursor-pointer"
                        onClick={() =>
                          handleEditSales(getOutletData.manager_details)
                        }
                      >
                        <Edit />
                      </button>
                    ) : (
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setIsSalesOpen(true);
                        }}
                      >
                        <AddPrimaryButton value="Add" />
                      </div>
                    )}
                  </div>
                  {getOutletData?.manager_details?.length > 0 ? (
                    <div className=" px-6 py-5">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        Person In-Charge
                      </p>
                      {getOutletData.manager_details.map((manager, index) => (
                        <div
                          key={manager.id || index}
                          className="text-sm font-normal text-primaryBlack font-Proxima flex"
                        >
                          <p className="text-sm font-normal text-mgrey mr-1">
                            {index + 1}.
                          </p>
                          {manager?.user?.full_name || "Unknown"}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="flex justify-center text-center items-center h-20">
                      <p className="text-sm text-textSecondary font-normal font-Proxima">
                        “No Manager" <br />
                        Start adding now!
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4">
                {/* Staff */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg h-64 overflow-auto overflow-y-auto">
                  <div className="flex items-center justify-between bg-background_grey py-4 px-6 border-b border-b-Grey">
                    <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey justify-center text-center">
                      <UserIconB />
                      <span>Staff</span>
                    </h2>
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        setModalData({
                          outletData,
                        });
                        setIsPreferredOpen(true);
                      }}
                    >
                      <AddPrimaryButton value="Add" />
                    </div>
                  </div>
                  {getOutletData?.outlet_staff?.length ? (
                    <div className="px-6 py-4 h-44 overflow-visible">
                      <table className="w-full text-left table-fixed">
                        <tbody>
                          {getOutletData?.outlet_staff?.map((tech, index) => (
                            <tr
                              key={index}
                              className="border-b border-textGrey"
                            >
                              <td className="w-1/6 px-4 py-4 text-sm font-normal text-mgrey">
                                {index + 1}
                              </td>
                              <td className="w-1/6 px-4 py-4 text-sm font-medium text-themeBtn cursor-pointer font-Proxima">
                                {tech?.user?.full_name}
                              </td>
                              <td className="w-1/6 px-4 py-4 text-sm font-medium text-mgrey font-Proxima">
                                {tech?.user?.phone}
                              </td>
                              <td className="w-1/6 px-4 py-4 text-sm font-normal text-mgrey font-Proxima truncate">
                                {tech?.user?.email}
                              </td>
                              <td className="w-1/6 px-4 py-4">
                                <Toggles
                                  checked={tech?.user?.is_active === 1}
                                  toggleFor={tech?.user?.id}
                                  onChange={() => handleToggle(tech?.user)}
                                />
                              </td>
                              <td className="w-1/6 px-4 py-4">
                                <Action
                                  optionList={
                                    <>
                                      <li
                                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                        onClick={() =>
                                          navigate(
                                            "/create-edit-staff-account",
                                            {
                                              state: {
                                                staff: tech?.user,
                                                mode: "edit",
                                                outletData: tech,
                                              },
                                            }
                                          )
                                        }
                                      >
                                        View/Edit
                                      </li>
                                      <li
                                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                        onClick={() => {
                                          setModalData({
                                            tech,
                                            mode: "staff",
                                          });
                                          setIsTransfer(true);
                                        }}
                                      >
                                        Transfer
                                      </li>
                                      <li
                                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                        onClick={() => {
                                          SetStaffDelete(true);
                                          setProductDelete(tech?.id);
                                        }}
                                      >
                                        Delete
                                      </li>
                                    </>
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div>
                      <div className="flex justify-center text-center h-44 items-center">
                        <p className="text-[14px] text-textSecondary font-normal font-Proxima">
                          “No Staff" <br />
                          Start adding now!
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                {/* Equipment */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg h-64 overflow-x-hidden overflow-y-auto">
                  <div className="flex items-center justify-between bg-background_grey py-4 px-6 border-b border-b-Grey">
                    <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey justify-center text-center">
                      <UserIconB />
                      <span>Equipments</span>
                    </h2>
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        setModalData({
                          outletData,
                        });
                        setIsEquipmentOpen(true);
                      }}
                    >
                      <AddPrimaryButton value="Add" />
                    </div>
                  </div>
                  {getOutletData?.equipment?.length ? (
                    <div className="px-6 py-4 h-44">
                      <table className="w-full text-left table-fixed">
                        <tbody>
                          {getOutletData?.equipment?.map((tech, index) => (
                            <tr
                              key={index}
                              className="border-b border-textGrey"
                            >
                              <td className="py-4 text-sm font-normal text-mgrey">
                                {index + 1}
                              </td>
                              <td className=" text-sm font-medium text-themeBtn cursor-pointer font-Proxima">
                                {tech?.on_site_name || "-"}
                              </td>
                              <td className=" text-sm font-medium text-mgrey font-Proxima">
                                {tech?.category_name || "-"}
                              </td>
                              <td className="py-4 text-sm font-normal text-mgrey font-Proxima">
                                Warrenty End:{<br />}
                                {tech?.warranty_expiry_date || "-"}
                              </td>
                              <td>
                                <div className="flex justify-start">
                                  <Badge
                                    className={`capitalize ${
                                      tech?.warranty_status === "In Warranty"
                                        ? "border-borderGreen text-bgGreen"
                                        : tech?.warranty_status === "Unknown"
                                        ? "border-gray text-gray"
                                        : "-"
                                    }`}
                                    value={
                                      tech?.warranty_status === "In Warranty"
                                        ? "In Warranty"
                                        : tech?.warranty_status === "Unknown"
                                        ? "Unknown"
                                        : "-"
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                <Action
                                  optionList={
                                    <>
                                      <li
                                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                        onClick={() => {
                                          setModalData({
                                            outletData: tech,
                                            mode: "edit",
                                          });
                                          setIsEquipmentOpen(true);
                                        }}
                                      >
                                        View/Edit
                                      </li>
                                      <li
                                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                        onClick={() => {
                                          setModalData({
                                            tech,
                                            mode: "equipment",
                                          });
                                          setIsTransfer(true);
                                        }}
                                      >
                                        Transfer
                                      </li>
                                      <li
                                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                        onClick={() => {
                                          SetEquipmentDelete(true);
                                          setProductDelete(tech?.id);
                                        }}
                                      >
                                        Delete
                                      </li>
                                    </>
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div>
                      <div className="flex justify-center text-center h-44 items-center">
                        <p className="text-[14px] text-textSecondary font-normal font-Proxima">
                          “No Equipment" <br />
                          Start adding now!
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {isModalOpen && (
        <div>
          <EditGeneralDetails
            onClose={closeModal}
            outletData={getOutletData}
            isEdit={true}
          />
        </div>
      )}
      {isPreferredOpen && (
        <div>
          <AddEditStaff
            onClose={closeModal}
            company={companyData}
            modalData={modalData}
          />
        </div>
      )}
      {isEquipmentOpen && (
        <div>
          <AddNewEquipment
            onClose={closeModal}
            company={companyData}
            modalData={modalData}
          />
        </div>
      )}
      {isSalesOpen && (
        <div>
          <AddEditManager
            onClose={handleCloseSalesModal}
            companyId={companyData}
            managerData={managerData}
            modalData={getOutletData}
          />
        </div>
      )}

      {isTransfer && (
        <AddEditTransfer
          onClose={closeModal}
          company={companyData}
          modalData={modalData}
          outletData={getOutletData}
        />
      )}

      {equipmentDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              SetEquipmentDelete(false);
            }}
            onConfirm={deleteEquipment}
            isLoading={isLoading}
          />
        </div>
      )}

      {staffDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              SetStaffDelete(false);
            }}
            onConfirm={deleteStaff}
            isLoading={isLoading}
          />
        </div>
      )}
    </>
  );
};

export default OutletInformation;
